<template>
  <div class="admin_user">
    <el-divider content-position="left">个人信息</el-divider>
    <el-row>
      <el-col :span="12">
        <dd-qrcode-login :user="user" bindState="qyh_bind_me"></dd-qrcode-login>
      </el-col>
      <el-col :span="12">
        <qw-qrcode-login :user="user"></qw-qrcode-login>
      </el-col>
    </el-row>
    <el-row style="margin-top: 20px">
      <el-col :span="12">
        <div class="demo-image">
          <span class="check-title">企业火支付宝小程序专属二维码：</span>
          <span class="dian_button" @click="getQyhAliQrCode">
            <el-image v-if="user.qyh_app_ali_qrcode" style="width: 3rem; height: 3rem"
                      :src="user.qyh_app_ali_qrcode"></el-image>
            <i v-else class="el-icon-plus avatar-uploader-icon"></i>
          </span>
        </div>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import DdQrcodeLogin from '@/pages/authority/common/DdQrcodeLogin'
import QwQrcodeLogin from '@/pages/authority/common/QwQrcodeLogin'
export default {
  name: 'AdminUser',
  components: { DdQrcodeLogin, QwQrcodeLogin },
  props: {
    user: Object
  },
  data () {
    return {
      bindState: 'qyh_bind_me'
    }
  },
  methods: {
    getQyhAliQrCode () {
      this.$axios
        .get('/api/admin/admin_user/ali_qrcode')
        .then(res => {
          const { data } = res
          if (data.code === 0) {
            this.user.qyh_app_ali_qrcode = data.data.qyh_app_ali_qrcode
            this.$message.success(data.msg)
          } else {
            this.$message.error(data.msg)
          }
        })
    }
  },
  mounted () {
  }
}
</script>

<style lang="stylus" scoped>
@import '~styles/varibles.styl'
@import '~styles/vertical.styl'
.admin_user
  marginLeft()
.avatar-uploader-icon {
  font-size: 0.4rem;
  color: #8c939d;
  width: 3rem;
  height: 3rem;
  line-height: 3rem;
  text-align: center;
  border: 1px black dotted;
}
.dian_button {
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/pages/admin_user/AdminUser.vue